import { useState, useEffect } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitButton } from "ui-components/Form";

import MDBox from "components/MDBox";
import { Card } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { formRender, initialValues, teamRoleValidation } from "./team-role-schema";
import TeamRoleInfo from "./components/TeamRoleInfo";
import { Success, Error } from "ui-components/Alert";

import { createTeamRole } from "services/data.internal.service";
import Layout from "layouts/views/components/Layout";
import { InboundLayout } from "ui-components/Layout";
function NewTeamRole() {
  const [alert, setAlert] = useState(null);
  const [expanded, setExpanded] = useState([]);

  const form = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(teamRoleValidation),
  });

  const {
    register,
    control,
    formState: { errors },
    setValue,
    getValues,
    watch,
    handleSubmit,
    reset
  } = form;
  const teamRoleProp = {
    formRender,
    control,
    errors,
    watch,
    setValue,
    expanded,
    setExpanded
  };

  const createTeamRoleMutation = useMutation(createTeamRole, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError: (data) => {
      setAlert(<Error data={data} onChange={setAlert} />);
    },
  });

  const onSubmit = async () => {
    window.scrollTo(0, 0);
    if (alert !== null) {
      setAlert(null);
    }
    const values = getValues();

    if (!values.permission || values.permission.length === 0) {
      setAlert(<Error content="Permissions are required" onChange={setAlert}/>);
      return;
    }
    const req = {
      ...values
    };

    createTeamRoleMutation.mutate(
      {
        ...req,
      },
      {
        onSuccess: () => {
          reset();
          setExpanded([]);
        },
      }
    );
  };

  const addStatus = createTeamRoleMutation.status === "loading";

  return (
    <InboundLayout lg={12}>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Card sx={{ height: "100%" }}>
          <MDBox p={3}>
            <TeamRoleInfo {...teamRoleProp} />
          </MDBox>
          <MDBox p={3}>
            <SubmitButton label="Submit" disabled={addStatus} url="/user/team-role"/>
          </MDBox>
        </Card>
      </form>
    </InboundLayout>
  );
}

export default NewTeamRole